<template>


<div class="slider-group form-group" ref="salaryslider">

        <label>{{ lng.salary }}
          <!--<select  v-model="currency"-->
          <!--@change="setCurrency">-->
              <!--<option value="usd">$</option>-->
              <!--<option value="euro">€</option>-->
          <!--</select>-->
        </label>


        <div class="slider-group-box">
          <div class="slider-input-box">
            <input type="text" :value="salary.value[0]"
                ref="sfrom" class="numfield slider-group-box__input  slider-group-box__input_salary"
                data-ref="salary" data-refval="first">
            <span> - </span>
            <input type="text" :value="salary.value[1]"
                ref="sto" class="numfield slider-group-box__input slider-group-box__input_salary"
                data-ref="salary" data-refval="second">
          </div>
          <button @click.prevent="handlerSendSalary" class="btn btn-slider">Set</button>
        </div>

      <vue-slider ref="salary" @drag-end="stopDrag" v-bind="salary" v-model="salary.value"></vue-slider>

</div>




</template>

<script>
import vueSlider from 'vue-slider-component';
import {mapActions, mapGetters} from 'vuex';

export default {
    components: {
        vueSlider
   },
   data(){
      return {
        currency: 'usd',
        salary: {
            value: [0, 22000],
            min: 0,
            max: 22000,
            interval: 500,
            dotSize: 10,
            tooltip: 'none',
            width: "auto"

        }
      }
   },

   computed: {
        ...mapGetters([
            'lng',
            'dataRequest'
        ])
   },
   methods: {
        ...mapActions([
            'prepareRequest',
            'sendRequest'
        ]),

        setCurrency(){
            this.prepareRequest({key: 'salary', val: 1});
            this.prepareRequest({key: 'currency', val: this.currency});
            this.sendRequest();
        },

        stopDrag(e){
          this.prepareRequest({key: 'salary', val: 1});
          this.prepareRequest({key: 'sfrom', val: e.value[0] });
          this.prepareRequest({key: 'sto', val: e.value[1] });
          this.sendRequest();
         },
         handlerSendSalary(){


            const sfrom = this.$refs.sfrom;
            const fromVal = sfrom.value
            const sto = this.$refs.sto;
            const toVal = sto.value

            let val = this.salary.value;

            if(parseInt(fromVal) >= parseInt(toVal)) {
                this.salary.value = [this.salary.min, this.salary.max];
                sfrom.value = this.salary.min;
                sto.value = this.salary.max;
            }
            if(parseInt(toVal) > parseInt(val[1])) {
                sfrom.value = this.salary.min;
                 sto.value = this.salary.max;
            }
            if(parseInt(fromVal) <= 0 ) {
                 sfrom.value = 1;
             }
             console.log('prepare')

             this.salary.value = [sfrom.value, sto.value];
             this.prepareRequest({key: 'duration', val: 1});
             this.prepareRequest({key: 'dfrom', val: this.salary.value[0]});
             this.prepareRequest({key: 'dto', val: this.salary.value[1] });
             this.sendRequest();


         }



   }
}
</script>

<style>


#ranks-filter .slider-group-box__input {
    margin-left: 1em;
}
#ranks-filter  .h3-span {
    margin-bottom: 0;
    margin-top: 1em;
}


</style>


// WEBPACK FOOTER //
// Salary.vue?5bbec26a